import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", () => {
  let brochureCookie = {};
  let inputsNumber = document.querySelectorAll(".number-brochure");
  for (const inputNumber of inputsNumber) {
    inputNumber.addEventListener("change", (e) => {
      console.log(e);
      if (inputNumber.value > 0) {
        brochureCookie[inputNumber.dataset.slug] = {
          name: inputNumber.dataset.title,
          quantity: inputNumber.value,
          image: inputNumber.dataset.img,
          translate: inputNumber.dataset.translate,
        };
      } else {
        delete brochureCookie[inputNumber.dataset.slug];
      }
      Cookies.set("order-brochure", JSON.stringify(brochureCookie), {
        expires: 3650,
        path: "/",
      });
      if (document.querySelectorAll(".js-brochures-ordered").length > 0) {
        delete brochureCookie[inputNumber.dataset.slug].image;
        delete brochureCookie[inputNumber.dataset.slug].translate;
        document.querySelector(".js-brochures-ordered").value = JSON.stringify(brochureCookie);
      }
    });
  }

  if (document.querySelectorAll("#cookieBrochure").length > 0) {
    let inputHiddenBrochures = document.getElementById("cookieBrochure");
    let cookie = JSON.parse(Cookies.get("order-brochure"));
    let text = "";
    Object.entries(cookie).forEach((entry) => {
      const [key, value] = entry;
      text += value.name + " ," + value.translate + " " + value.quantity + "<br>";
    });
    inputHiddenBrochures.value = text;
  }

  if (document.querySelectorAll("#dataBrochures").length > 0) {
    let data = document.getElementById("dataBrochures");
    let cookie = JSON.parse(Cookies.get("order-brochure"));
    let text = "";
    Object.entries(cookie).forEach((entry) => {
      const [key, value] = entry;
      text += '<div class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col md:flex-row items-center gap-[40px] bg-white p-[20px] rounded-[10px]"><div class="h-[140px] overflow-hidden"><img src="' + value.image + '" class="w-full h-full object-contain"></div><div class="w-full"><p class="text-[18px] leading-[27px]"><span class="font-semibold">' + value.name + "</span><br /> " + value.translate + " " + value.quantity + "</p></div></div>";
    });
    data.innerHTML = text;
  }
});
